import { Container, Grid } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { BaseHeader } from '../../../global/ui';
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import LoginStore from './LoginStore';

function LoginContainer() {
  return (
    <>
      <BaseHeader />
      <Container maxWidth='lg'>
        <Grid container justifyContent='center'>
          <Grid item style={{ maxWidth: 450, width: 450 }}>
            <Grid container direction='column' justifyContent='center' style={{ height: '65vh' }}>
              {LoginStore.screen === 'forgot' ? <ForgotPassword /> : <Login />}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default observer(LoginContainer);
